import React, { useState } from 'react';
import { MatchConnections } from './MatchConnections';
import { ConnectionReveal } from '../components/ConnectionReveal';
import { useLanguage } from '../components/LanguageContext';
import { PageHeader } from '../components/PageHeader';
import { MockProfile } from '../data/mockProfiles';
interface Props {
  onScanPress: () => void;
}
export function MatchContainer({
  onScanPress
}: Props) {
  const {
    t
  } = useLanguage();
  const [revealData, setRevealData] = useState<{
    profile: MockProfile;
    slotId: string;
  } | null>(null);
  // If reveal page is active, render it above everything
  if (revealData) {
    return <ConnectionReveal profile={revealData.profile} initialSlotId={revealData.slotId} onBack={() => setRevealData(null)} data-id="element-466" />;
  }
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] overflow-hidden relative" data-id="element-467">
      <PageHeader title="Connessioni" data-id="element-468" />
      <div className="flex-1 overflow-hidden min-h-0" data-id="element-469">
        <MatchConnections onAcceptReveal={(profile, slotId) => setRevealData({
        profile,
        slotId
      })} data-id="element-470" />
      </div>
    </div>;
}